import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';

import ApiService from '../../../services/api.service';
import { URL_CONSTANTS } from '../../../constants/urlConstants';

const initialState = {
  userSkillLevelList: [],
  status: false,
  error: null,
};

export const fetchUserSkillLevelList = createAsyncThunk(
  'master/fetchUserSkillLevelList',
  async () => {
    const response = await ApiService.getWithDiffBaseUrl(
      `/auth/user/manage/skill`,
      {},
      URL_CONSTANTS.USER_META.baseUrl
    );
    return response?.data || [];
  }
);

const userSkillLevelSlice = createSlice({
  name: 'userSkillLevelList',
  initialState,
  reducers: {
    clearUserSkillLevelList: state => {
      state.userSkillLevelList = [];
      state.status = false;
      state.error = null;
    },
  },
  extraReducers: builder => {
    builder
      .addCase(fetchUserSkillLevelList.pending, state => {
        state.status = 'loading';
      })
      .addCase(fetchUserSkillLevelList.fulfilled, (state, action) => {
        state.status = 'succeeded';
        state.userSkillLevelList = action?.payload || [];
      })
      .addCase(fetchUserSkillLevelList.rejected, (state, action) => {
        state.status = 'failed';
        state.error = action.error.message;
      });
  },
});

export const { clearUserSkillLevelList } = userSkillLevelSlice.actions;

export const userSkillLevelReducer = userSkillLevelSlice.reducer;
